module.exports = __webpack_public_path__ + "static/media/video_on.89e1a7c7.svg";